module.exports = __webpack_public_path__ + "img/SMBC.e4ad3f76.png";